import classNames from 'classnames';
import { ButtonHTMLAttributes, forwardRef, Ref } from 'react';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean,
  grow?: boolean
};

export const Button = forwardRef(({ active, children, className, grow=true, ...props }: ButtonProps, ref: Ref<HTMLButtonElement>) => (
  <button
    className={
      classNames(
        'disabled:bg-gray-400 shadow',
        'border-y border-r first-of-type:rounded-l-sm first-of-type:border-l',
        'last-of-type:rounded-r-sm',
        'p-2 flex items-center justify-center',
        {
          'grow basis-0': grow,
          'text-white bg-jw-mid-blue hover:bg-jw-light-blue': !active,
          'bg-blue-200 text-neutral-800 hover:bg-blue-200': active
        },
        className
      )
    }
    ref={ref}
    {...props}
  >
    { children }
  </button>
));
